import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CSSTransition } from 'react-transition-group'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './balloon_tooltip.scss'

class BalloonTooltip extends Component {

	constructor() {
		super()

		this.state = {
			isOpen: false,
		}
	}

	openTooltip() {
		this.setState({
			isOpen: true,
		})
	}

	closeTooltip() {
		this.setState({
			isOpen: false,
		})
	}

	render() {
		return (
			<span styleName='container'>
				<CSSTransition
					in={(this.props.isOpen||this.state.isOpen)}
					classNames={{
						enter: styles.enter,
						enterActive: styles['enter-active'],
						exit: styles.exit,
						exitActive: styles['exit-active'],
					}}
					timeout={300}
					unmountOnExit
				>
					<div
						style={{width: this.props.width, height: this.props.height}}
						styleName={classNames({
							balloon: true,
							['position--'+this.props.position]: true,
						})
						}>
						{this.props.tooltip}
					</div>
				</CSSTransition>
				<div
					styleName='icon'
					onMouseEnter={this.props.onMouseEnterHandler||this.openTooltip.bind(this)}
					onMouseLeave={this.props.onMouseLeaveHandler||this.closeTooltip.bind(this)}
				>
					{this.props.children}
				</div>
			</span>
		)
	}
}

BalloonTooltip.propTypes = {
	onMouseEnterHandler: PropTypes.func,
	onMouseLeaveHandler: PropTypes.func,
	tooltip: PropTypes.string,
	children: PropTypes.node,
	isOpen: PropTypes.bool,
	position: PropTypes.string,
}

BalloonTooltip.defaultProps = {
	position: 'top',
}

export default CSSModules(BalloonTooltip, styles, {allowMultiple: true})
